export default "__VITE_ASSET__6d8486a2__"